import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';

const MarkdownParagraphRenderer = ({ children }) => (
	<Typography variant='body1'>{children}</Typography>
);

MarkdownParagraphRenderer.propTypes = {
	children: PropTypes.node.isRequired,
};

export default MarkdownParagraphRenderer;
